export default {
  name: 'division',
  type: 'layout',
  data: {
    width: 1,
    style: 'solid',
    color: ''
  }
}
